import { render } from "./LostParts.vue?vue&type=template&id=0a59256a"
import script from "./LostParts.vue?vue&type=script&lang=js"
export * from "./LostParts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__